import React from "react";
import UaeBloreHead from "../../UaeAttestation/UaeBlore/UaeBloreHead";
import NigeriaBloreMain from "./NigeriaBloreMain";

const NigeriaBlore = () => {
  return (
    <div className="uaeBloreContainer">
      <UaeBloreHead head="Nigeria Attestation in Bangalore" />
      <NigeriaBloreMain />
    </div>
  );
};

export default NigeriaBlore;
